import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";

interface I_aux {
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    obj_new: any ,
}

export const Modalverhistorico: React.FC<I_aux> = ({
    flag_open_modal,
    set_flag_open_modal,
    obj_new,

}) => {



    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Histórico

                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>
            <div className="flex flex-col w-full gap-5 p-5 rounded-xl bg-gray-50/80">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-5 w-full items-start">
                    <div className="w-full">
                        <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                            Total Horas
                        </div>
                        <div className="text-base font-medium text-gray-800">
                            {obj_new?.total_horas ?? '-'}
                        </div>
                    </div>

                    <div className="w-full">
                        <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                            Total Custo
                        </div>
                        <div className="text-base font-medium text-gray-800">
                            {obj_new?.total_custo !== undefined && obj_new?.total_custo !== null
                                ? `€ ${Number(obj_new.total_custo).toFixed(2)}`
                                : '-'}
                        </div>
                    </div>

                    <div className="w-full">
                        <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                            Nº Operações
                        </div>
                        <div className="text-base font-medium text-gray-800">
                            {obj_new?.num_operacoes ?? '-'}
                        </div>
                    </div>
                </div>
            </div>



        </div>



    </Modal >)

}
